module.exports = __webpack_public_path__ + "img/mixcolor.96a8e8ca.png";